import React from "react";

//Import Styled
import { About, Description, Hide, Image } from "../styles";
import home1 from "../img/home1.png";
//Animation
import { motion } from "framer-motion";
import { titleAnim, fade, photoAnim } from "../Animation";
import Wave from "./Wave";
const AboutSection = () => {
  return (
    <About>
      <Description>
        <div className="title">
          <Hide className="hide">
            <motion.h2 variants={titleAnim}>We work to make</motion.h2>
          </Hide>
          <Hide className="hide">
            <motion.h2 variants={titleAnim}>
              your <span>dreams</span> come
            </motion.h2>
          </Hide>
          <Hide className="hide">
            <motion.h2 variants={titleAnim}> true.</motion.h2>
          </Hide>
        </div>
        <motion.p variants={fade}>
          Contact us for any photography or videography ides that you have. we
          have profesionals with amazing skills
        </motion.p>
        <motion.button variants={fade}>Contact Us</motion.button>
      </Description>
      <Image>
        <motion.img variants={photoAnim} src={home1} alt="home" />
      </Image>
      <Wave />
    </About>
  );
};

export default AboutSection;
